import { t } from "@/i18n-js/instance";
import { UsageDetailsSection } from "./UsageDetailsSection";
import { UsageMetric } from "./UsageMetric";

const localeRoot = "settings.billing.manage_billing.usage_details.ai_actions";

export const AiActionsUsageDetails = () => (
  <UsageDetailsSection title={t(`${localeRoot}.title`)} showMenu>
    <UsageMetric
      title={t(`${localeRoot}.credits.title`)}
      progress={50}
      description={t(`${localeRoot}.credits.description`)}
      price={t(`${localeRoot}.credits.price`)}
    />
  </UsageDetailsSection>
);
